import React from "react";
import classNames from "classnames";
import {NavLink as RRNavLink, useRouteMatch} from "react-router-dom";
import focusHeader from "shared/Experimental/A11y/components/SkipNav/FocusHeader";
import s from "./NavLink.pcss";

export default function NavLink({className, icon, to = {}, ...props}) {
    const isActive = !!useRouteMatch(to);

    return (
        <RRNavLink
            {...props}
            to={to}
            className={classNames([s.navlink], className)}
            activeClassName={s.navlinkActive}
            onClick={() => focusHeader("content")}
        >
            <React.Fragment>
                {typeof icon === "function" ? icon({isActive}) : null}
                {props.children}
            </React.Fragment>
        </RRNavLink>
    );
}
